import { render } from "./install.vue?vue&type=template&id=c1ba95a6"
import script from "./install.vue?vue&type=script&lang=js"
export * from "./install.vue?vue&type=script&lang=js"

import "./install.vue?vue&type=style&index=0&id=c1ba95a6&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__